import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Art } from "./Art";
import { Reveal } from "./Reveal";

export const Btn = ({ to, children, variant = "primary", className = "", testid, ...rest }) => (
  <Link to={to} className={`btn btn-${variant} ${className}`} data-testid={testid} {...rest}>
    {children} <ArrowRight className="arr h-4 w-4" />
  </Link>
);

export const ServiceCard = ({ title, slug, art, short, index = 0, code }) => (
  <Reveal delay={(index % 3) * 0.06} className="h-full">
    <Link to={`/services/${slug}`} data-testid={`service-card-${slug}`}
      className="svc-card group flex h-full flex-col border border-[#102A43]/12 bg-white">
      <div className="relative aspect-[400/240] overflow-hidden bg-[#0E2438] grid-dark">
        <Art kind={art} className="svc-art absolute inset-0 h-full w-full p-4" />
        {code && <span className="absolute left-3 top-3 font-mono text-[11px] tracking-widest text-[#D8B66A]">{code}</span>}
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="svc-title font-display text-lg font-bold leading-snug text-[#102A43]">{title}</h3>
        {short && <p className="mt-3 text-sm leading-relaxed text-[#526579] flex-1">{short}</p>}
        <span className="mt-5 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.16em] text-[#1769AA]">
          <span className="u-link">Learn More</span><ArrowRight className="arr h-4 w-4" />
        </span>
      </div>
    </Link>
  </Reveal>
);

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-[#b8c7d6]">
      {items.map(([label, to], i) => (
        <li key={label} className="flex items-center gap-2">
          {i > 0 && <ChevronRight className="h-3 w-3 opacity-60" />}
          {to ? <Link to={to} className="u-link hover:text-white">{label}</Link> : <span aria-current="page" className="text-[#D8B66A]">{label}</span>}
        </li>
      ))}
    </ol>
  </nav>
);
